import { useApplicationContext } from '../../utils/applicationContext';

export const useIsDailyrentOnlineBookingEnabled = () => {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Dailyrent.OnlineBookingFrontend.Enabled');
};
